import { useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiError, getClientId, saveLead } from "@/lib/api";

export const EmailGateDialog = ({ open, onOpenChange, tool, onUnlocked }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const isImage = tool === "social_image";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/leads", { name, email, tool, client_id: getClientId() });
      saveLead(data);
      toast.success(isImage ? `¡Listo, ${data.name}! Ya puedes crear tus imágenes.` : `¡Listo, ${data.name}! Ya tienes acceso ilimitado.`);
      onOpenChange(false);
      onUnlocked(data);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="ai-tool-email-modal" className="rounded-2xl border-[#E8E1D7] bg-[#FAF7F2] sm:max-w-md">
        <DialogHeader>
          <div className="mb-2 grid h-12 w-12 place-items-center rounded-xl bg-[#E05A47] text-white"><Lock className="h-5 w-5" /></div>
          <DialogTitle className="font-display text-2xl">Desbloquea las herramientas</DialogTitle>
          <DialogDescription>
            {isImage
              ? "Déjanos tu nombre y email para crear tus imágenes gratis: hasta 3 al día. Sin spam."
              : "Déjanos tu nombre y email para copiar tus resultados y seguir creando sin límite. Gratis, sin spam."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="mt-2 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="gate-name">Tu nombre</Label>
            <Input id="gate-name" required value={name} onChange={(e) => setName(e.target.value)} data-testid="email-gate-name-input" className="h-11 bg-white" placeholder="María" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="gate-email">Tu email</Label>
            <Input id="gate-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="email-gate-email-input" className="h-11 bg-white" placeholder="maria@minegocio.com" />
          </div>
          <Button type="submit" disabled={loading} data-testid="email-gate-submit-button" className="h-11 w-full rounded-full bg-[#E05A47] hover:bg-[#c94a38]">
            {loading ? "Guardando…" : "Desbloquear gratis"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
